<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>
              <i class="fa fa-align-justify"></i> Bénéficiaire : {{ nom }} {{ prenom }}
            </strong>
          </div>
          <b-form id="fiche-beneficiaire">
            <b-tabs>
              <b-tab active>
                <template slot="title">
                  <i class="icon-user"></i>
                  {{ tabs[0] }}
                </template>
                <b-card-body>
                  <b-row>
                    <b-col sm="6">
                      <b-form-group label="Nom" :label-cols="3" :horizontal="true" style="font-weight:bold">
                        <b-form-input type="text"
                                      ref="nom" :value="nom" :disabled="!isEditing" v-model="nom"/>
                      </b-form-group>

                      <b-form-group label="Prénom" :label-cols="3" :horizontal="true" style="font-weight:bold">
                        <b-form-input type="text"
                                      ref="prenom" :value="prenom" :disabled="!isEditing" v-model="prenom"/>
                      </b-form-group>

                      <b-form-group label="Email" :label-cols="3" :horizontal="true" style="font-weight:bold">
                        <b-form-input type="text"
                                      ref="email" :value="email" v-if="inscription == ''" :disabled="true"
                                      :class="{hasError: errors.email !== ''}" v-model="email"/>
                        <b-form-input type="text"
                                      ref="email" :value="email" v-else :disabled="!isEditing"
                                      :class="{hasError: errors.email !== ''}" v-model="email"/>
                        <span class="field-error">{{ errors.email }}</span>
                      </b-form-group>

                      <b-form-group hidden label="Date de naissance" :label-cols="3" :horizontal="true"
                                    style="font-weight:bold">
                        <b-form-input type="date"
                                      ref="date_naissance" :value="date_naissance" :disabled="!isEditing"
                                      v-model="date_naissance"/>
                      </b-form-group>

                      <b-form-group label="Téléphone" :label-cols="3" :horizontal="true" style="font-weight:bold">
                        <b-form-input type="text"
                                      ref="numero_tel" :value="numero_tel" :disabled="!isEditing" v-model="numero_tel"/>
                      </b-form-group>

                      <b-form-group label="Adresse" :label-cols="3" :horizontal="true" style="font-weight:bold">
                        <b-form-input type="text"
                                      ref="adresse" :value="adresse" :disabled="!isEditing" v-model="adresse"/>
                      </b-form-group>

                      <b-form-group label="Code postal" :label-cols="3" :horizontal="true" style="font-weight:bold">
                        <b-form-input type="text"
                                      ref="code_postal" :value="code_postal" :disabled="!isEditing"
                                      v-model="code_postal"/>
                      </b-form-group>

                      <b-form-group label="Ville" :label-cols="3" :horizontal="true" style="font-weight:bold">
                        <b-form-input type="text"
                                      ref="ville" :value="ville" :disabled="!isEditing" v-model="ville"/>
                      </b-form-group>

                      <b-form-group label="Pays" :label-cols="3" :horizontal="true" style="font-weight:bold">
                        <b-form-input type="text"
                                      ref="pays" :value="pays" :disabled="!isEditing" v-model="pays"/>
                      </b-form-group>

                      <div slot="footer" class="text-center">
                        <b-button type="button"
                                  @click="isEditing = !isEditing" v-if="!isEditing" variant="primary"
                                  class="pull-right">
                          <i class="fa fa-edit"></i> Modifier
                        </b-button>
                        <b-button type="button"
                                  @click="update" v-if="isEditing" variant="primary" class="pull-right">
                          <i class="fa fa-save"></i> Enregistrer
                        </b-button>
                        <b-button type="button"
                                  style="margin-right:20px;" @click="isEditing = false" v-if="isEditing"
                                  variant="secondary" class="pull-right">
                          <i class="fa fa-ban"></i> Annuler
                        </b-button>
                      </div>
                    </b-col>

                    <b-col sm="6">
                      <b-form-group label="N° Sécurité Sociale" :label-cols="3" :horizontal="true"
                                    style="font-weight:bold">
                        <b-form-text type="text">
                          <h5>{{ formatNir(nir) }}</h5>
                        </b-form-text>
                      </b-form-group>

                      <b-form-group label="N° dossier" :label-cols="3" :horizontal="true" style="font-weight:bold">
                        <b-form-text type="text"
                                     v-for="dossier in num_dossier" v-bind:key="dossier.numeroDossier">
                          <h5>{{ dossier.numeroDossier }}</h5>
                        </b-form-text>
                      </b-form-group>

                      <b-form-group label="N°Identifiant NSI" :label-cols="3" :horizontal="true"
                                    style="font-weight:bold">
                        <b-form-text type="text">
                          <h5>{{ identifiant }}</h5>
                        </b-form-text>
                        <b-form-input type="text"
                                      ref="email_send" :disabled="isEditing" placeholder="Adresse email "
                                      :class="{hasError: errors.email_send !== ''}" v-if="showSendIdentifiant"
                                      v-model="email_send"/>
                        <span class="field-error">{{ errors.email_send }}</span>
                        <div>
                          <b-button type="button"
                                    @click="sendIdentifiant" v-if="showSendIdentifiant"
                                    class="btn badge-primary btn-secondary">
                            <i class="fa fa-send"></i> Envoyer identifiant
                          </b-button>
                        </div>
                      </b-form-group>

                      <b-form-group label="Type de rente" :label-cols="3" :horizontal="true" style="font-weight:bold">
                        <b-form-text type="text"
                                     v-for="typeRente in type_rente" v-bind:key="typeRente">
                          <h5>{{ typeRente }}</h5>
                        </b-form-text>
                      </b-form-group>

                      <b-form-group v-if="inscription != ''" label="Inscrit le" :label-cols="3" :horizontal="true"
                                    style="font-weight:bold">
                        <b-form-text type="text">
                          <h5>{{ formatDate(inscription) }}</h5>
                        </b-form-text>
                      </b-form-group>

                      <b-form-group v-else label="Inscrit le" :label-cols="3" :horizontal="true"
                                    style="font-weight:bold">
                        <b-form-text type="text">
                          <h5>{{ inscription }}</h5>
                        </b-form-text>
                      </b-form-group>

                      <b-form-group label="Compte" :label-cols="3" :horizontal="true" style="font-weight:bold">
                        <b-form-text type="text">
                          <h5>
                            {{ isActif }}
                            <span v-if="isActif=='Actif'" class="badge badge-success p-1" style="margin-left:10px">
                              <i class="fa fa-check"></i>
                            </span>
                            <span v-else-if="isActif != ''" class="badge badge-danger p-1" style="margin-left:10px">
                              <i class="fa fa-close"></i>
                            </span>
                          </h5>
                          <br>
                          <h5>Dernière connexion le : {{ dateConnexion }}</h5>
                        </b-form-text>
                        <b-button type="button"
                                  @click="sendActivation" v-if="showSendActivation"
                                  class="btn badge-primary btn-secondary">
                          <i class="fa fa-send"></i> Envoyer lien d'activation
                        </b-button>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-tab>

              <b-tab>
                <template slot="title">
                  <i class="cui-comment-square"></i>
                  {{ tabs[1] }}
                </template>
                <b-card-body>
                  <contact-tab :benefId="benefId"></contact-tab>
                </b-card-body>
              </b-tab>

              <b-tab>
                <template slot="title">
                  <i class="cui-paperclip"></i>
                  {{ tabs[2] }}
                </template>
                <b-card-body>
                  <justificatif-beneficiaire :benefId="benefId"></justificatif-beneficiaire>
                </b-card-body>
              </b-tab>

              <b-tab>
                <template slot="title">
                  <i class="icon-docs"></i>
                  {{ tabs[3] }}
                </template>
                <b-card-body>
                  <decompte-beneficiaire :benefId="benefId"></decompte-beneficiaire>
                </b-card-body>
              </b-tab>

              <b-tab>
                <template slot="title">
                  <i class="icon-badge"></i>
                  {{ tabs[4] }}
                </template>
                <b-card-body>
                  <attestation-tab :benefId="benefId"></attestation-tab>
                </b-card-body>
              </b-tab>
              <b-tab v-if="hasRule(rules.ACCESS_FICHE_BENEFICIAIRE_JOURNAL)">
                <template slot="title">
                  <i class="icon-docs"></i>
                  {{ tabs[5] }}
                </template>
                <b-card-body>
                  <journal-beneficiaire :benefId="benefId"></journal-beneficiaire>
                </b-card-body>
              </b-tab>
            </b-tabs>

            <div slot="footer" style="margin-top:25px;">
              <b-button type="button" @click="returnBack" size="md" variant="secondary">
                <i class="fa fa-arrow-left"></i> Liste des bénéficiaires
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {getBaseUrl, getProvider, getIdToken, getAccessToken} from '../../utils/auth'
  import ContactTab from '@/components/ContactTab.vue'
  import DecompteBeneficiaire from '@/components/DecompteBeneficiaire.vue'
  import JustificatifBeneficiaire from '@/components/JustificatifBeneficiaire.vue';
  import JournalBeneficiaire from '@/components/JournalBeneficiaire.vue';
  import AttestationTab from '@/components/AttestationTab.vue';
  import {espaceBeneficiaireRules as rules, hasRule} from "@/utils/rulesHelper";
  import { formatDateTime } from "@/utils/communHelper";

  export default {
    components: {
      ContactTab,
      DecompteBeneficiaire,
      JustificatifBeneficiaire,
      AttestationTab,
      JournalBeneficiaire
    },
    data() {
      return {
        benefId: this.$route.params.id,
        isEditing: false,
        num_dossier: "",
        nir: "",
        nom: "",
        prenom: "",
        email: "",
        numero_tel: "",
        date_naissance: "",
        adresse: "",
        code_postal: "",
        ville: "",
        pays: "",
        type_rente: "",
        identifiant: "",
        inscription: "",
        isActif: "",
        dateConnexion: "",
        email_send: "",
        getJustificatifs: false,
        getDecomptes: false,
        getContacts: false,
        getInfos: false,
        errors: {email: "", email_send: ""},
        showSendIdentifiant: false,
        showSendActivation: false,
        tabs: [
          "Fiche",
          "Contacts",
          "Pièces justificatives",
          "Décomptes",
          "Attestations",
          "Journal"
        ],
        justificatifsColumns: ["num_dossier", "nom", "prenom", "status"],
        justificatifsItems: [],
        justificatifsOptions: {
          headings: {
            num_dossier: "N° Dossier",
            nom: "Nom",
            prenom: "Prénom",
            status: "Statut"
          },
          sortable: [],
          filterable: ["num_dossier"],
          perPage: 5,
          perPageValues: [5, 10, 20],
          texts: {
            filterPlaceholder: "N° Dossier"
          },
          orderBy: {column: "num_dossier"}
        },
        hasRule,
        rules
      };
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();

    },
    mounted() {
      if (this.$route.params.id) {
        this.show();
        this.$event.emit('refreshBeneficiaire');
      }
      // Gestion du Loading
      this.$event.on('getDecomptes', () => {
        if (this.getInfos && this.getJustificatifs && this.getContacts) {
          this.$store.commit("IS_LOADING", false)
        }
        this.getDecomptes = true
      })
      this.$event.on('getContacts', () => {
        if (this.getInfos && this.getJustificatifs && this.getDecomptes) {
          this.$store.commit("IS_LOADING", false)
        }
        this.getContacts = true
      })
      this.$event.on('getJustificatifs', () => {
        if (this.getInfos && this.getContacts && this.getDecomptes) {
          this.$store.commit("IS_LOADING", false)
        }
        this.getJustificatifs = true
      })
    },
    methods: {
      update() {
        if (this.validateData()) {
          let dataPost = {};
          dataPost.nom = this.nom;
          dataPost.prenom = this.prenom;
          dataPost.email = this.email;
          dataPost.date_naissance = this.date_naissance;
          dataPost.numero_tel = this.numero_tel;
          dataPost.adresse = this.adresse;
          dataPost.code_postal = this.code_postal;
          dataPost.ville = this.ville;
          dataPost.pays = this.pays;
          dataPost.user_id = this.$route.params.id;

          let self = this;
          this.$store.commit("IS_LOADING", true);
          this.$axios
            .put("/espaceBeneficiaire/beneficiaires/edit", dataPost)
            .then(response => {
              this.$event.emit('refreshBeneficiaire');
              this.$store.commit("IS_LOADING", false);
              this.$swal({
                position: "top",
                type: "success",
                title: "Modification avec succès",
                text: "Le compte de " + dataPost.prenom + " " + dataPost.nom + " a bien été modifié",
                showConfirmButton: false,
                timer: 5000
              });
            })
            .catch(function (error) {
              self.$store.commit("IS_LOADING", false);
              self.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
                showConfirmButton: false,
                timer: 5000
              });
            });
          this.isEditing = !this.isEditing;
        }
      },
      sendActivation() {
        let dataPost = {};
        dataPost.user_id = this.$route.params.id;

        let self = this;
        this.$store.commit("IS_LOADING", true);
        this.$axios
          .put("/espaceBeneficiaire/beneficiaires/sendactivation", dataPost)
          .then(response => {
            this.$event.emit('refreshBeneficiaire');
            this.$store.commit("IS_LOADING", false);
            this.showSendActivation = false
            this.$swal({
              position: "top",
              type: "success",
              title: "Message envoyé avec succès",
              text: "Le mail d'activation a bien été envoyé au bénéficiaire, il est valable 7 jours à partir de maintenant.",
              showConfirmButton: false,
              timer: 5000
            });
          })
          .catch(function (error) {
            self.$store.commit("IS_LOADING", false);
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
      sendIdentifiant() {
        if (this.validateEmailSend()) {
          let dataPost = {}
          dataPost.user_id = this.$route.params.id
          dataPost.email = this.email_send

          let self = this
          this.$store.commit("IS_LOADING", true)
          this.$axios
            .put("/espaceBeneficiaire/beneficiaires/sendidentifiant", dataPost)
            .then(response => {
              this.$event.emit('refreshBeneficiaire');
              this.$store.commit("IS_LOADING", false)
              this.showSendIdentifiant = false
              this.$swal({
                position: "top",
                type: "success",
                title: "Message envoyé avec succès",
                text: "Le mail contenant l'identifiant a bien été envoyé au bénéficiaire",
                showConfirmButton: false,
                timer: 5000
              })
            })
            .catch(function (error) {
              self.$store.commit("IS_LOADING", false)
              self.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
                showConfirmButton: false,
                timer: 5000
              })
            })
        }

        this.email_send = ''
      },
      show() {
        this.$store.commit("IS_LOADING", true);
        let id = this.$route.params.id;
        this.$axios
          .get("/espaceBeneficiaire/beneficiaires/fiche/" + id)
          .then(response => {
            this.id = response.data.user.id
            this.nom = response.data.user.nom
            this.prenom = response.data.user.prenom
            this.email = response.data.user.login ? response.data.user.login.email : ""
            this.date_naissance = response.data.user.date_naissance
            this.numero_tel = response.data.user.numero_tel
            this.adresse = response.data.user.adresse
            this.code_postal = response.data.user.code_postal
            this.ville = response.data.user.ville
            this.pays = response.data.user.pays
            this.nir = response.data.user.nir

            let listOfObjects = Object.keys(response.data.user.numeroDossier).map(
              key => {
                return response.data.user.numeroDossier[key];
              }
            );
            this.num_dossier = listOfObjects
            this.type_rente = response.data.user.typeRente

            this.justificatifsItems = response.data.user.justificatifs
            this.buildData(response.data.user.justificatifs)

            this.identifiant = response.data.user.id_pp + response.data.user.nom.substring(0, 2)

            this.inscription = ""
            this.isActif = "Non actif"

            if (response.data.user.login) {
              this.inscription = response.data.user.login.created_at
              //this.inscription = formatDate(this.inscription)
              if (response.data.user.login.active) {
                this.isActif = "Actif"
              } else {
                this.showSendActivation = true
              }
              if(response.data.user.login.date_connexion){
                  this.dateConnexion = this.getFormattedDateTime(response.data.user.login.date_connexion, '/');
              }
            } else {
              this.showSendIdentifiant = true
            }
            if (this.getContacts && this.getDecomptes && this.getJustificatifs) {
              this.$store.commit("IS_LOADING", false)
            }
            this.getInfos = true
          })
          .catch(function (error) {
          });
      },
      buildData(data) {
        let groupedData = _.groupBy(data, "num_evt")
        let result = []
        for (let nsi in groupedData) {
          let sentJustificatifs = groupedData[nsi].filter(
            pj => pj.is_sent === true
          );
          result.push({
            id: nsi,
            id_pp_dest_reglement: nsi,
            num_dossier: groupedData[nsi][0].num_evt,
            nomDest: groupedData[nsi][0].nomdest,
            prenomDest: groupedData[nsi][0].prenomdest,
            status: {
              text:
                sentJustificatifs.length === Object.keys(groupedData[nsi]).length ? "Envoyé" : "En Attente",
              isSent:
                sentJustificatifs.length === Object.keys(groupedData[nsi]).length ? true : false
            },
            data: groupedData[nsi]
          })
        }
        this.justificatifsItems = result
      },
      formatDate(textDate) {
        let date = textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-"
        return date
      },
      getFormattedDateTime(textDate) {
        if(textDate !== null && textDate !== ''){
          return formatDateTime(textDate, '/');
        }
      },
      validateData() {
        this.clearErrors()
        let regEmail = this.$store.getters.getRegMail
        let valid = true
        if (this.inscription !== '') {
          if (this.email === "") {
            this.errors.email = "L'adresse email est obligatoire"
            valid = false
          } else if (!regEmail.test(this.email.trim())) {
            valid = false
            this.errors.email = "Veuillez entrer une adresse mail valide"
          }
        }
        return valid
      },
      validateEmailSend() {
        this.errors.email_send = ""
        let regEmail = this.$store.getters.getRegMail
        let valid = true

        if (this.email_send === "") {
          this.errors.email_send = "L'adresse email de destination est obligatoire"
          valid = false
        } else if (!regEmail.test(this.email_send.trim())) {
          valid = false
          this.errors.email_send = "Veuillez entrer une adresse mail de destination valide"
        }
        return valid
      },
      formatNir(textNir) {
        if (textNir !== null && textNir.length === 15) {
          return textNir.substring(0, 13) + ' ' + textNir.substring(13, 15)
        } else {
          return textNir;
        }
      },
      clearErrors() {
        this.errors.email = ""
      },
      returnBack() {
        // this.$router.push({ path: '/espace-beneficiaire/beneficiaires' })
        this.$router.push({path: "/espace-beneficiaire/beneficiaires",
          query: {
            in: this.$route.query.in,
            do: this.$route.query.do,
            ns: this.$route.query.ns,
            no: this.$route.query.no,
            pr: this.$route.query.pr,
            em: this.$route.query.em,
            co: this.$route.query.co,
            de: this.$route.query.de
          }
        })
      }
    }
  };
</script>

<style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>
